import orderBy from 'lodash/orderBy';
import formatDate from './format-date';

const sortedCardList = srcProfiles => {
  let mergedCards = [];

  // only iterate if srcProfiles is an array
  Array.isArray(srcProfiles) &&
    srcProfiles.forEach(networkProfile => {
      // card brand and corr id to be added to each card object
      let network = Object.keys(networkProfile)[0];

      const srcCorrelationId = networkProfile[network]?.srcCorrelationId ?? [];

      const profiles =
        networkProfile[network] && Array.isArray(networkProfile[network].profiles)
          ? networkProfile[network].profiles
          : [];

      // it's possible for networks to return multiple profiles, so iterate through
      profiles.forEach(profile => {
        const cardList = Array.isArray(profile.cardList) ? profile.cardList : [];

        // each card needs network correlation id and card error (if ineligible) added to it
        cardList.forEach(cardItem => {
          const card = Object.assign({}, cardItem);
          //update network if cardItem has network value
          network = cardItem.networkId ? cardItem.networkId : network;
          //TODO need to handle mastercard mapping a better way
          card.network = network === 'MA' ? 'MASTERCARD' : network;
          card.srcCorrelationId = srcCorrelationId;

          // cardError will exist for visa cards with errors. Force eligible to false for these card so that
          // when sorted, they appear after cards that are eligible
          if (card.cardError) {
            card.eligible = false;
          }

          // add generic error if cardError not present (cardError only present for Visa)
          if (card.eligible === false) {
            card.cardError = card.cardError ? card.cardError : 'generic_error';
          }

          // add card to the merged card array
          mergedCards = mergedCards.concat(card);
        });
      });
    });

  // return the sorted the card array
  // cards need to be grouped by eligibility (cards without errors displayed first),
  // then sorted in descending order by dateOfCardLastUsed and then in ascending order of dateOfCardCreated

  /* START GENAI@GHCOPILOT */
  const eligibleCards = mergedCards.filter(cardObj => cardObj.eligible !== false);
  const ineligibleCards = mergedCards.filter(cardObj => cardObj.eligible === false);

  let usedEligibleCards = eligibleCards.filter(
    cardObj => cardObj.dateOfCardLastUsed !== undefined && cardObj.dateOfCardLastUsed !== null
  );

  let unusedEligibleCards = eligibleCards.filter(
    cardObj => cardObj.dateOfCardLastUsed === undefined || cardObj.dateOfCardLastUsed === null
  );

  let usedIneligibleCards = ineligibleCards.filter(
    cardObj => cardObj.dateOfCardLastUsed !== undefined && cardObj.dateOfCardLastUsed !== null
  );

  let unusedIneligibleCards = ineligibleCards.filter(
    cardObj => cardObj.dateOfCardLastUsed === undefined || cardObj.dateOfCardLastUsed === null
  );

  usedEligibleCards = orderBy(
    usedEligibleCards,
    [
      cardObj => formatDate(cardObj.dateOfCardLastUsed),
      cardObj => formatDate(cardObj.dateOfCardCreated)
    ],
    ['desc', 'asc']
  );

  unusedEligibleCards = orderBy(
    unusedEligibleCards,
    [cardObj => formatDate(cardObj.dateOfCardCreated)],
    ['asc']
  );

  usedIneligibleCards = orderBy(
    usedIneligibleCards,
    [
      cardObj => formatDate(cardObj.dateOfCardLastUsed),
      cardObj => formatDate(cardObj.dateOfCardCreated)
    ],
    ['desc', 'asc']
  );

  unusedIneligibleCards = orderBy(
    unusedIneligibleCards,
    [cardObj => formatDate(cardObj.dateOfCardCreated)],
    ['asc']
  );

  return usedEligibleCards.concat(unusedEligibleCards, usedIneligibleCards, unusedIneligibleCards);
};

export default sortedCardList;
